import { authConstants, siteConstants } from "../../constants";
import { authServices } from "../../services";
import { alertActions } from ".";

const login = (username, password, otpToken) => {
  const request = (user) => {
    return {
      type: authConstants.LOGIN_REQUEST,
      payload: {
        username,
        password,
        otpToken,
      }
    };
  }

  const success = (data) => {
    return {
      type: authConstants.LOGIN_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: authConstants.LOGIN_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(username, password, otpToken));
    authServices.getTokenPair(username, password, otpToken)
      .then(response => {
        const data = response.data;
        const { access, refresh } = data;
        authServices.updateTokensInLocalStorage(access, refresh);
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response.status === 401)
          dispatch(alertActions.error(error.response.data.detail));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION));

        dispatch(failure());
      });
  };
}

const logout = () => {
  return dispatch => {
    dispatch({
      type: authConstants.LOGOUT,
      payload: null,
    });
    authServices.clearTokensInLocalStorage();
    window.location = "/"
  };
}

const getUser = () => {
  const request = () => {
    return {
      type: authConstants.GET_USER_REQUEST,
      payload: null,
    };
  }

  const success = (data) => {
    return {
      type: authConstants.GET_USER_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: authConstants.GET_USER_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request());
    authServices.getUser()
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(alertActions.error(siteConstants.ERROR_MSG_FAILED_TO_RETRIEVE_USER));
        dispatch(failure());
      });
  };
}

const changePassword = (currentPassword, newPassword) => {
  const request = (currentPassword, newPassword) => {
    return {
      type: authConstants.CHANGE_PASSWORD_REQUEST,
      payload: {
        currentPassword,
        newPassword,
      },
    };
  }

  const success = (data) => {
    return {
      type: authConstants.CHANGE_PASSWORD_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: authConstants.CHANGE_PASSWORD_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(currentPassword, newPassword));
    authServices.changePassword(currentPassword, newPassword)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
        authServices.clearTokensInLocalStorage();
        window.location = "/"
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION));

        dispatch(failure());
      });
  };
}

export const authActions = {
  login,
  logout,
  getUser,
  changePassword,
};